'use client';

import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

export default function DevotionalPlanCard({ devotionalPlan, onDevotionalClick, onHistoryClick }) {
  return (
    <div className="bg-card rounded-xl p-6 border border-border hover-lift">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-crimson font-semibold text-foreground">Today's Devotional</h3>
        <button 
          onClick={onHistoryClick}
          className="text-primary hover:text-primary/80 contemplative-transition"
          title="View all previous devotionals"
        >
          <Icon name="CalendarDaysIcon" size={24} />
        </button>
      </div>
      <div className="space-y-4">
        {devotionalPlan?.slug ? (
          <Link href={`/devotionals/${devotionalPlan?.slug}`}>
            <div 
              className="p-4 bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg cursor-pointer hover:from-primary/10 hover:to-accent/10 contemplative-transition"
              title="Click to read full devotion"
            >
              <h4 className="font-crimson font-semibold text-foreground mb-2">{devotionalPlan?.title}</h4>
              <p className="text-sm font-source-serif text-muted-foreground mb-3">{devotionalPlan?.verse}</p>
              <p className="text-sm font-inter text-foreground">{devotionalPlan?.reflection}</p>
              <div className="flex items-center justify-center mt-3 pt-3 border-t border-border/30">
                <span className="text-xs font-inter text-primary hover:text-primary/80">
                  Click to read full devotion →
                </span>
              </div>
            </div>
          </Link>
        ) : (
          <div 
            className="p-4 bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg cursor-pointer hover:from-primary/10 hover:to-accent/10 contemplative-transition"
            onClick={onDevotionalClick}
            title="Click to read full devotion"
          >
            <h4 className="font-crimson font-semibold text-foreground mb-2">{devotionalPlan?.title}</h4>
            <p className="text-sm font-source-serif text-muted-foreground mb-3">{devotionalPlan?.verse}</p>
            <p className="text-sm font-inter text-foreground">{devotionalPlan?.reflection}</p>
            <div className="flex items-center justify-center mt-3 pt-3 border-t border-border/30">
              <span className="text-xs font-inter text-primary hover:text-primary/80">
                Click to read full devotion →
              </span>
            </div>
          </div>
        )}
        
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="ClockIcon" size={16} className="text-muted-foreground" />
            <span className="text-sm font-inter text-muted-foreground">{devotionalPlan?.readingTime} min read</span>
          </div>
          <button className="flex items-center space-x-2 px-3 py-1 bg-primary/10 text-primary rounded-lg font-inter font-medium text-sm hover:bg-primary/20 contemplative-transition">
            <Icon name="CheckIcon" size={16} />
            <span>Mark Complete</span>
          </button>
        </div>
        
        <div className="pt-2 border-t border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="font-inter text-muted-foreground">Plan Progress</span>
            <span className="font-inter font-medium text-foreground">{devotionalPlan?.planProgress}/30 days</span>
          </div>
          <div className="w-full bg-muted rounded-full h-1.5 mt-2">
            <div 
              className="bg-primary h-1.5 rounded-full transition-all duration-300"
              style={{ width: `${(devotionalPlan?.planProgress / 30) * 100}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

DevotionalPlanCard.propTypes = {
  devotionalPlan: PropTypes?.shape({
    slug: PropTypes?.string,
    title: PropTypes?.string?.isRequired,
    verse: PropTypes?.string?.isRequired,
    reflection: PropTypes?.string?.isRequired,
    readingTime: PropTypes?.number?.isRequired,
    planProgress: PropTypes?.number?.isRequired
  })?.isRequired,
  onDevotionalClick: PropTypes?.func?.isRequired,
  onHistoryClick: PropTypes?.func?.isRequired
};